import { Subrand } from "graphql/generated-types";
import Image from "next/image";
import React from "react";
import ArrowLink from "./ArrowLink";
import { removeRootPage } from "@/lib/utils";
import SubArrowLink from "./SubArrowLink";

const SubrandSection = ({ subrand }: { subrand: Subrand }) => {
	return (
		<section className="border-t-3 border-navy odd:border-b-3 pb-[3.75rem] pt-11 lg:py-[1.875rem]">
			<div className="to-lg:gap-5 container grid gap-x-5 lg:grid-cols-2">
				<h3 className="order-1 text-xl lg:self-end lg:text-3xl">{subrand.name}</h3>
				<div className="order-3">
					<p className="mt-1 max-w-[35rem] text-lg leading-tight lg:text-xl">{subrand.description}</p>
					<ArrowLink
						className="mb-2 mt-6 lg:mb-4 lg:mt-12"
						href={removeRootPage(subrand.link?.urlPath!)}
						text={`Learn more about ${subrand.name}`}
					/>
					{subrand.products?.map((product, i) => (
						<SubArrowLink key={i} href={removeRootPage(product?.page?.urlPath!)} text={product?.name!} />
					))}
				</div>
				<Image
					className="order-2 justify-self-end lg:row-span-2"
					src={subrand.image?.rendition?.url!}
					alt={subrand.image?.rendition?.image?.title!}
					width={1050}
					height={810}
				/>
			</div>
		</section>
	);
};

export default SubrandSection;
